import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Inject, OnChanges, Input, EventEmitter, Output, DoCheck} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { ControlContainer, NgForm } from '@angular/forms';
import  DateHelpers  from '../../../_infrastructure/DateHelpers';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';

@Component({
    selector: 'effectivity-timeline',
    templateUrl: './effectivity-timeline.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class EffectivityTimelineComponent implements OnInit, OnDestroy, OnChanges,DoCheck {

  public periodList: models.TimelinePeriodVM[]; 

  @Input() public effectivityList: models.EffectivityEntryVM[];
  @Input() public listChangeSubject: Subject<any>;
  @Output() public timeLineClick: EventEmitter<models.TimelinePeriodVM> = new EventEmitter();

  public subscriber: models.SubscriberInformationVM;


  public get minDate() {
    return !isNullOrUndefined(this.effectivityMapMinDate) ? this.effectivityMapMinDate : this.dateOfBirthPlus12(this.subscriber?.dateOfBirth);
  };

  dateOfBirthPlus12(dob : Date) {
    var result: Date = new Date(dob);
    result.setFullYear(result.getFullYear() + 12);
    return result;
  }

  @Input() public effectivityMapMinDate: Date;
  public maxDate: Date = new Date();
  fectivi
  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private subscriberinfoService: SubscriberInformationService) {
  }

  ngOnInit(): void {
    if (!isNullOrUndefined(this.listChangeSubject))
      this.listChangeSubject.subscribe(x => this.buildPeriodList());

    this.subscriberinfoService.getCurrentSubscriber().subscribe((subscriber) => {
      this.subscriber = subscriber;
      this.buildPeriodList();
    });
  }

  ngOnDestroy(): void {
  }

  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
  }

  ngOnChanges(): void {
    if (isNullOrUndefined(this.periodList))
      this.periodList = [];
   
    this.buildPeriodList();
  }

  buildPeriodList() {
    var selectedPeriod = this.periodList.find(period => period.active == true);
    this.periodList = [];

    if (isNullOrUndefined(this.effectivityList) || this.effectivityList.length == 0)
      this.buildEmptyPeriodList();
    else
      this.buildPeriodListFromEffectivities(selectedPeriod);
  }

  buildEmptyPeriodList() : void {
    this.periodList.push({ startDate: this.minDate, endDate: this.maxDate, active: false, sizePercentage: 100, hasEffectivity: false });
  }

  buildPeriodListFromEffectivities(selectedPeriod  : models.TimelinePeriodVM): void  {

    //TODO : See if it is possible to refactor this method, or at the very least optimize it a bit (remove/realocate sorts etc...)
    var sortedEffectivities = this.effectivityList.slice().filter(effectivity => !isNullOrUndefined(effectivity.startDate) && !isNullOrUndefined(effectivity.endDate)).sort((first, second) => first.startDate.getTime() - second.startDate.getTime());

    //From effectivities gets the curren periods defined
    sortedEffectivities.forEach(effectivity => {
      var containingPeriodIndex = this.periodList.findIndex(period =>
        (effectivity.startDate <= period.endDate && effectivity.startDate >= period.startDate) || (DateHelpers.isDatesAdjacent(effectivity.startDate, period.endDate) || (DateHelpers.isDatesAdjacent(effectivity.endDate, period.startDate))));

      if (containingPeriodIndex == -1)
        this.periodList.push({ startDate: effectivity.startDate, endDate: effectivity.endDate, active: false, sizePercentage: 0 ,hasEffectivity: true});
      else
        this.periodList[containingPeriodIndex].endDate = this.periodList[containingPeriodIndex].endDate <= effectivity.endDate ? effectivity.endDate : this.periodList[containingPeriodIndex].endDate;
    });

    this.periodList.sort((first, second) => first.startDate.getTime() - second.startDate.getTime());

    //Pushes if missing the empty period at start and finish (acording to minDate and maxDate)
    if (this.periodList[0].startDate > this.minDate)
      this.periodList.splice(0, 0, { startDate: this.minDate, endDate: DateHelpers.addDays(this.periodList[0].startDate ,-1), active: false, sizePercentage: 0, hasEffectivity: false});

    if (this.periodList[this.periodList.length - 1].endDate < DateHelpers.truncateDate(this.maxDate))
      this.periodList.push({ startDate: DateHelpers.addDays(this.periodList[this.periodList.length - 1].endDate,1), endDate: this.maxDate, active: false, sizePercentage: 0, hasEffectivity: false })

    var missingPeriods: models.TimelinePeriodVM[] = [];

    //Calculates the gap periods that are missing
    this.periodList.forEach((element, index, array) => {
      if (index <= this.periodList.length - 2 && !DateHelpers.isDatesAdjacent(element.endDate, array[index + 1].startDate) ) {
        missingPeriods.push({ startDate: DateHelpers.addDays(element.endDate, 1), endDate: DateHelpers.addDays(array[index + 1].startDate,-1), active: false, sizePercentage: 0, hasEffectivity: false});
      }
    });

    //Merges the provided periods with the missing ones
    this.periodList = this.periodList.concat(missingPeriods).sort((first, second) => first.startDate.getTime() - second.startDate.getTime());

    //Calculates the % of space each period should ocupy
    var totalTime = this.periodList[this.periodList.length - 1].endDate.getTime() - this.periodList[0].startDate.getTime();
    this.periodList = this.periodList.map(period => {
      return {
        ...period,
        sizePercentage: Math.floor(((period.endDate.getTime() - period.startDate.getTime()) / totalTime) * 100),
        active : isNullOrUndefined(selectedPeriod) ? false : selectedPeriod.startDate <= period.endDate && selectedPeriod.startDate >= period.startDate
      }
    })
    this.periodList[this.periodList.length - 1].sizePercentage = this.periodList[this.periodList.length - 1].sizePercentage + (100 - _.sumBy(this.periodList, (x) => { return x.sizePercentage }));
  }

  onPeriodClick(index: number): void {
    this.periodList.forEach((element, i) => element.active = index == i ? this.periodList[index].hasEffectivity ? !element.active : false : false);
    this.timeLineClick.emit({ ...this.periodList[index] });
  }
}
